import {
  HeaderLink,
  HeaderLinkSection,
  useLayoutData,
} from '@/context/LayoutDataContext'

export interface MenuSubLink {
  id: string
  title: string
  url: string
  isNew: boolean
}

export interface MenuLink {
  id: string
  title: string
  url?: string
  isDefault?: boolean
  children: MenuSubLink[] | null
  nestedSections?: CmsLinkSection[]
  subtitle?: string
}

export interface CmsLinkSection {
  id: string
  title: string
  isDefault?: boolean
  headerLinks?: MenuSubLink[]
  headerLinkSections?: CmsLinkSection[]
  children?: MenuSubLink[] | null
  subtitle?: string
}

export const useMenuLinks = (): MenuLink[] => {
  const { header } = useLayoutData()

  const mappedChildren = (section: HeaderLinkSection, isNested: boolean) => {
    return section.fields.headerLinkSections?.length || isNested
      ? section.fields.headerLinks.map((link: HeaderLink) => ({
          id: link.sys.id,
          title: link.fields.title,
          url: link.fields.url,
          isNew: link.fields.isNew,
        }))
      : null
  }

  return header.fields.headerLinkSections.map((section: HeaderLinkSection) => ({
    id: section.sys.id,
    title: section.fields.title,
    subtitle: section.fields.subtitle,
    url: section.fields.headerLinks[0]?.fields.url,
    isDefault: section.fields.isDefault,
    children: mappedChildren(section, false),
    nestedSections: section.fields.headerLinkSections?.map(
      (section: HeaderLinkSection) => ({
        id: section.sys.id,
        title: section.fields.title,
        subtitle: section.fields.subtitle,
        children: mappedChildren(section, true),
      }),
    ),
  }))
}
